"use client";

interface SkeletonProps {
  className?: string;
  /** Width in CSS units. Defaults to "100%". */
  width?: string;
  /** Height in CSS units. Defaults to "1rem". */
  height?: string;
  /** Rounds to pill shape when true. */
  rounded?: boolean;
}

export function Skeleton({
  className = "",
  width = "100%",
  height = "1rem",
  rounded = false,
}: SkeletonProps) {
  // GAM Brand v2: skeletons use input radius (smaller) so they hint at the
  // shape of the field they're replacing. Pills (rounded=true) stay pills.
  return (
    <div
      className={[
        "animate-pulse bg-slate-700/40",
        rounded ? "rounded-full" : "",
        className,
      ].join(" ")}
      style={{
        width,
        height,
        borderRadius: rounded ? undefined : "var(--gam-radius-input, 0.5rem)",
      }}
    />
  );
}

/** Row of skeletons mimicking a card list */
export function SkeletonCard({ lines = 3 }: { lines?: number }) {
  return (
    <div
      style={{ borderRadius: "var(--gam-radius-card, 0.75rem)" }}
      className="space-y-2.5 border border-white/[0.06] bg-white/[0.02] p-4"
    >
      <Skeleton width="40%" height="0.875rem" />
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} width={i === lines - 1 ? "60%" : "100%"} height="0.75rem" />
      ))}
    </div>
  );
}
